import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MyTranslationService {
  private currentLang: string = 'ar';

  constructor(
    private translateService: TranslateService,
    @Inject(PLATFORM_ID) private platId: object
  ) {
    if (isPlatformBrowser(this.platId)) {
      const savedLang = localStorage.getItem('lang') || 'ar';
      this.currentLang = savedLang;

      this.translateService.setDefaultLang('ar'); // fallback
      this.translateService.use(this.currentLang);

      this.applyChanges();
    }
  }

  private applyChanges(): void {
    if (!isPlatformBrowser(this.platId)) return;

    this.changeDirection();
    this.changeStyle();
  }

  changeDirection(): void {
    if (!isPlatformBrowser(this.platId)) return;

    document.documentElement.setAttribute(
      'dir',
      this.currentLang === 'ar' ? 'rtl' : 'ltr'
    );
  }

  changeStyle(): void {
    if (!isPlatformBrowser(this.platId)) return;

    const styleId = 'changeStyle';
    let styleLink = document.getElementById(styleId) as HTMLLinkElement | null;

    if (!styleLink) {
      styleLink = document.createElement('link');
      styleLink.id = styleId;
      styleLink.rel = 'stylesheet';
      document.head.appendChild(styleLink);
    }

    styleLink.href =
      this.currentLang === 'ar'
        ? '/css/style-ar.css'
        : '/css/style-en.css';
  }

  changeLang(lang: string): void {
    if (!isPlatformBrowser(this.platId)) return;

    localStorage.setItem('lang', lang);
    this.currentLang = lang;

    this.translateService.use(lang);
    this.applyChanges();
    if (isPlatformBrowser(this.platId)) {
      window.location.reload();
    }
  }

  getCurrentLang(): string {
    return this.currentLang;
  }
}
